import { types } from "../action_types";

const INITIAL_STATE = {
  getLoading: false,
  createLoading: false,
  editLoading: false,
  deleteLoading: false,
  blockchains: null,
  pagination: null,
};

const BlockchainsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GetBlockchainsRequest:
      return { ...state, getLoading: true };
    case types.GetBlockchainsRequestSuccess:
      return {
        ...state,
        blockchains: payload.blockchains,
        pagination: payload.pagination,
        getLoading: false,
      };
    case types.GetBlockchainsRequestFailure:
      return { ...state, getLoading: false };

    case types.CreateBlockchainsRequest:
      return { ...state, createLoading: true };
    case types.CreateBlockchainsRequestSuccess:
      return { ...state, createLoading: false };
    case types.CreateBlockchainsRequestFailure:
      return { ...state, createLoading: false };

    case types.EditBlockchainsRequest:
      return { ...state, editLoading: true };
    case types.EditBlockchainsRequestSuccess:
      return { ...state, editLoading: false };
    case types.EditBlockchainsRequestFailure:
      return { ...state, editLoading: false };

    case types.DeleteBlockchainsRequest:
      return { ...state, deleteLoading: true };
    case types.DeleteBlockchainsRequestSuccess:
      return { ...state, deleteLoading: false };
    case types.DeleteBlockchainsRequestFailure:
      return { ...state, deleteLoading: false };

    default:
      return state;
  }
};
export default BlockchainsReducer;
